import React from "react";
import MenuGrid from "../MenuGrid";

// El menu sigue el flujo real de la casa: se levanta la orden, se le entrega
// material al maquilero, el maquilero corta y confecciona por su cuenta, y lo
// unico que regresa es prenda terminada. Aqui no hay sala de corte propia, asi
// que el modulo no se organiza alrededor del corte sino de la maquila.
const SECTIONS = [
  {
    title: "Órdenes",
    items: [
      { label: "Órdenes de Maquila",    icon: "fas fa-people-carry", href: "/ListadoCortes",       perm: "menu_produccion" },
      { label: "Maquileros",            icon: "fas fa-dolly",        href: "/Maquileros",          perm: "menu_proveedores" },
    ],
  },
  {
    title: "Material en poder del maquilero",
    items: [
      { label: "Entregar Material",          icon: "fas fa-exchange-alt", href: "/TraspasosMaterialesCreate",   perm: "menu_telas" },
      { label: "Material Entregado",         icon: "fas fa-list",         href: "/ListadoTraspasosMateriales",  perm: "menu_telas" },
      { label: "Existencias de Material",    icon: "fas fa-warehouse",    href: "/ExistenciasMateriales",       perm: "menu_telas" },
      { label: "Apartados de Tela",          icon: "fas fa-box-open",     href: "/ListadoApartados",            perm: "menu_produccion" },
      { label: "Requisición vs Salida",      icon: "fas fa-tasks",   href: "/ReporteSalidaHabilitacion",    perm: "menu_produccion" },
      { label: "Requisición de Pedidos",     icon: "fas fa-clipboard-list", href: "/ReporteRequisicion",   perm: "menu_produccion" },
    ],
  },
  {
    title: "Recepción de prenda terminada",
    items: [
      { label: "En Poder del Maquilero", icon: "fas fa-hourglass-half",   href: "/CortesPendientesRecibir", perm: "menu_produccion" },
      { label: "Entradas a Almacén",     icon: "fas fa-right-to-bracket", href: "/ListadoEntradasAlmacen",  perm: "menu_produccion" },
    ],
  },
  {
    title: "Reportes",
    items: [
      { label: "Producción por Artículo", icon: "fas fa-list",        href: "/ListadoArticulosCortes", perm: "menu_produccion"     },
      { label: "Costos de Maquila",       icon: "fas fa-dollar-sign", href: "/ReporteCostosCortes",    perm: "reporteCostosCortes" },
    ],
  },
];

function BotonesProduccion() {
  return (
    <MenuGrid
      title="Producción"
      subtitle="Órdenes, entrega de material al maquilero y recepción de prenda terminada"
      icon="fas fa-people-carry"
      accent={{ color: "#8b5cf6", bg: "#f5f3ff" }}
      gate="menu_produccion"
      sections={SECTIONS}
    />
  );
}

export default BotonesProduccion;
